import React, { useState } from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import {
  removeImages,
  reporterRegister,
  UploadkycDocumentImage,
  validateReporterEmail,
  validateReporterMobile,
} from "../../redux/reporter/ReporterSlice";

const AddReporter = () => {
  const dispatch = useDispatch();

  const { reporterKycImage, mobileNumberError, emailError } = useSelector((store) => store.reporter);

  const [messageApi, contextHolder] = message.useMessage();
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnPress, setBtnPress] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [errorMessageEmail, setErrorMessageEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [errorMessageMobile, setErrorMessageMobile] = useState("");
  const [district, setDistrict] = useState("");
  const [mandal, setMandal] = useState("");
  const [kycDocument, setKycDocument] = useState("");
  const [kycDocumentError, setKycDocumentError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const verifyEmail = (value) => {
    setEmail(value);
    dispatch(validateReporterEmail(value))

    if (emailError == false) {
      setErrorMessageEmail("Email already exist");
    }else{
      setErrorMessageEmail("");
    }
  };

  const verifyPhoneNumber = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
    setMobile(value);
    console.log("-------",mobileNumberError);
    if (value.length === 10) {
      dispatch(validateReporterMobile(value))
      
      if (mobileNumberError == false) {
        setErrorMessageMobile("Number already exist");
      }else{
        setErrorMessageMobile("");
      }
    } else {
      setErrorMessageMobile("Invalid phone number");
    }
  };

  const kycDocumentChange = (e) => {
    const value = e.target.value;
    setKycDocument(value);
  };

  const thumbnailChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        dispatch(UploadkycDocumentImage({ kycdocumentImage: reader.result }));
      }
    };
    reader.readAsDataURL(file);
  };

  const passwordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (value.length < 3) {
      setPasswordError("Password should be at least 3 characters");
    } else {
      setPasswordError("");
    }
  };

  const handleSubmit = () => {
    setBtnPress(true);
    if (
      !firstName ||
      !district ||
      !mandal ||
      !kycDocument ||
      reporterKycImage.length === 0 ||
      password.length < 0
    ) {
      messageApi.error("Please fill all required fields");
      return;
    }else{
      const formData = {
        name:firstName,
        email:email,
        mobile:mobile,
        district:district,
        mandal:mandal,
        kycdocument:kycDocument,
        kycdocumentImage: reporterKycImage,
        password:password,
      }
      dispatch(reporterRegister(formData));
      dispatch(removeImages());
      setFirstName("");
      setEmail("");
      setMobile("");
      setDistrict("");
      setMandal("");
      setKycDocument("");
      setKycDocumentError("");
      setPassword("");
      setPasswordError("");
      
    }
    setBtnLoading(true);
    setTimeout(() => {
      messageApi.success("Reporter added successfully!");
      setBtnLoading(false);
    }, 2000);
  };

  return (
    <>
      {contextHolder}
      <div className="main_fragment_container p-2">
        <div className="profile_container_header">
          <div className="profile_co_header_left">
            <span>Add Reporter</span>
          </div>
        </div>
        <div className="main_recha_container">
          <div className="inputs_container">
            <div className="dn_input_box">
              <TextField
                label="Full Name"
                type="text"
                className="input_style"
                error={!firstName && btnPress}
                helperText={
                  !firstName && btnPress ? "Please enter First Name" : ""
                }
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                autoComplete="off"
                size="small"
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Email"
                type="email"
                className="input_style"
                error={Boolean(errorMessageEmail)}
                helperText={errorMessageEmail}
                value={email}
                onChange={(e) => verifyEmail(e.target.value)}
                autoComplete="off"
                size="small"
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Mobile"
                type="text"
                className="input_style"
                error={Boolean(errorMessageMobile)}
                helperText={errorMessageMobile}
                value={mobile}
                onChange={verifyPhoneNumber}
                autoComplete="off"
                size="small"
                inputProps={{ maxLength: 10 }}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="District"
                type="text"
                className="input_style"
                error={!district && btnPress}
                helperText={
                  !district && btnPress ? "Please enter District" : ""
                }
                value={district}
                onChange={(e) => setDistrict(e.target.value)}
                autoComplete="off"
                size="small"
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Mandal"
                type="text"
                className="input_style"
                error={!mandal && btnPress}
                helperText={!mandal && btnPress ? "Please enter Mandal" : ""}
                value={mandal}
                onChange={(e) => setMandal(e.target.value)}
                autoComplete="off"
                size="small"
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="KYC Document"
                type="text"
                className="input_style"
                error={Boolean(kycDocumentError)}
                helperText={kycDocumentError}
                value={kycDocument}
                onChange={kycDocumentChange}
                autoComplete="off"
                size="small"
                inputProps={{ maxLength: 12 }}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Password"
                type="password"
                className="input_style"
                error={Boolean(passwordError)}
                helperText={passwordError}
                value={password}
                onChange={passwordChange}
                autoComplete="off"
                size="small"
              />
            </div>
            <div className="dn_input_box">
              <div className="input_style">
                <h6>KYC Document Image</h6>
                <input
                  type="file"
                  accept="image/*"
                  onChange={thumbnailChange}
                  style={
                    reporterKycImage.length === 0 && btnPress
                      ? { border: "1px solid red", background: "#ffe6e6" }
                      : {}
                  }
                />
                {reporterKycImage.length === 0 && btnPress && (
                  <h6 style={{ color: "tomato" }}>Please upload an image</h6>
                )}
                {reporterKycImage.length > 0 && (
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                      src={reporterKycImage[0]}
                      alt="reporterKycImage"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                    <button
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => dispatch(removeImages())}
                    >
                      &times;
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="button_container">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={btnLoading}
              >
                {btnLoading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddReporter;

